import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import 'reset-css/reset.css';
import '../color/color';
import '../typography/typography';
import css from './form-label.css';

const FormLabel = ({ children, htmlFor, tag, inverse, text }) => (
  <label
    className={classnames(css['ds-form-label'], {
      [css['ds-form-label--inverse']]: inverse,
    })}
    htmlFor={htmlFor}
  >
    <span>{text}</span>
    {tag && <span className='ds-form-tag'>{tag}</span>}
    {children}
  </label>
);

FormLabel.defaultProps = {
  children: null,
  tag: null,
  htmlFor: null,
  inverse: false,
  text: '',
};

FormLabel.propTypes = {
  children: PropTypes.node,
  tag: PropTypes.string,
  htmlFor: PropTypes.string,
  inverse: PropTypes.bool,
  text: PropTypes.string,
};

export default FormLabel;
